import React from "react";
import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import Card from "@mui/material/Card";
import CardMedia from "@mui/material/CardMedia";
import CircularProgress from "@mui/material/CircularProgress";

const AssetPreview = ({ url, loading }) => {
  if (loading) {
    return (
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          py: 4,
        }}
      >
        <CircularProgress size={40} />
      </Box>
    );
  }

  if (!url) {
    return null;
  }

  return (
    <Paper
      variant="outlined"
      sx={{ p: 2, mt: 2, borderRadius: 1, bgcolor: "#fafafa", maxWidth: 480 }}
    >
      <Card sx={{ boxShadow: "none", bgcolor: "transparent" }}>
        <CardMedia
          component="img"
          image={url}
          alt="Asset preview"
          sx={{ objectFit: "contain", maxHeight: 360, bgcolor: "grey.100" }}
        />
      </Card>
    </Paper>
  );
};

export default AssetPreview;
